
define(
    'jsx!components/tooltip',[
        "jquery",
        "underscore",
        "backbone",
        "react"
    ],
    function ($, _, Backbone, React) {
        return React.createClass({
            displayName: "Tooltip",
            getInitialState: function () {
                return {
                    show: false,
                }
            },
            getDefaultProps: function() {
                return {
                    direction: "up"
                }
            },
            toggleTooltip: function() {
                this.setState({
                    show: !this.state.show,
                });
            },
            render: function () {
                var tooltipTextClassNames = ["dashboard-tooltip", this.props.direction];
                var tooltipContainerClassNames = ["tooltip-container"];
                if (this.state.show) {
                    tooltipTextClassNames.push("show");
                }
                if (this.props.customClass !== undefined) {
                    tooltipContainerClassNames.push(this.props.customClass);
                } 

                return (
                    React.createElement("div", {
                        className: tooltipContainerClassNames.join(" "), 
                        onMouseEnter: this.toggleTooltip, 
                        onMouseLeave: this.toggleTooltip
                    }, 
                        React.createElement("div", {className: "tooltip-content"}, 
                            this.props.children, 
                            React.createElement("div", {className: tooltipTextClassNames.join(" ")}, 
                                this.props.title ? React.createElement("p", {className: "title"}, this.props.title): '', 
                                this.props.dangerousHTMLText ? React.createElement("div", {dangerouslySetInnerHTML: {__html: this.props.dangerousHTMLText}}) : this.props.text
                            )
                        )
                    )
                );
            }
        });
    }
);

